module.exports = __webpack_public_path__ + "img/CM-EC-25-Lincoln-Playful.4bdf5bf2.jpg";